// -- [Key outcomes cards - uniform cards; topic emphasis gets For you badge]

import type { OutcomeCard, RoleKey } from '@/types/content'
import { Card, ForYouBadge } from '@/components/ui/Card'
import { Section } from '@/components/ui/Section'

interface OutcomesSectionProps {
  cards: OutcomeCard[]
  roleKey: RoleKey
  emphasisedSections: string[]
}

export function OutcomesSection({
  cards,
  roleKey,
  emphasisedSections,
}: OutcomesSectionProps) {
  const isEmphasised = emphasisedSections.includes('outcomes')
  const visibleCards = cards.filter((card) => card.roleTags.includes(roleKey))

  return (
    <Section id="outcomes" bg="muted">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 motion-enter">
        Why Dealers Choose Drivible
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {visibleCards.map((card, i) => {
          const isActive = card.roleTags.includes(roleKey) && isEmphasised
          return (
            <Card
              key={card.id}
              emphasised={isActive}
              badge={isActive ? <ForYouBadge /> : undefined}
              enterDelay={Math.min(i, 5)}
              data-role-tags={card.roleTags.join(',')}
            >
              <h3 className="font-semibold text-lg text-gray-900 mb-2">{card.title}</h3>
              <p className="text-ink-muted text-sm leading-relaxed">{card.description}</p>
            </Card>
          )
        })}
      </div>
    </Section>
  )
}
